import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [
        ]
      }
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Home' }
        ]
      },
      component: () => import('./views/home.view.vue')
    },

    /* ** Modules Persons ** */
    {
      path: '/Personas',
      name: 'ViewPersonas',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Personas' }
        ]
      },
      component: () => import('./views/persons.view.vue')
    },
    {
      path: '/Personas/',
      name: 'ViewCreatePersonas',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Personas' },
          { name: 'Nuevo' }
        ]
      },
      component: () => import('./views/personCreate.view.vue')
    },
    {
      path: '/Personas/:id',
      name: 'ViewEditPersonas',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Personas' },
          { name: 'Editar' }
        ]
      },
      component: () => import('./views/personCreate.view.vue')
    },
    /* ** Module Catalogo ** */
    {
      path: '/Catalogo/Municipios',
      name: 'ViewMunicipios',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Municipios' }
        ]
      },
      component: () => import('./views/catalogo/municipios.view.vue')
    },
    {
      path: '/Catalogo/Distritos',
      name: 'ViewDistritos',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Distritos' }
        ]
      },
      component: () => import('./views/catalogo/distritos.view.vue')
    },
    {
      path: '/Catalogo/Secciones',
      name: 'ViewSecciones',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Secciones' }
        ]
      },
      component: () => import('./views/catalogo/secciones.view.vue')
    },
    /* ** Module Administracion ** */
    {
      path: '/Administracion/Usuarios',
      name: 'ViewUsers',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Usuarios' }
        ]
      },
      component: () => import('./views/administracion/users.view.vue')
    },
    {
      path: '/Administracion/Roles',
      name: 'ViewRoles',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Roles' }
        ]
      },
      component: () => import('./views/administracion/roles.view.vue')
    },
    {
      path: '/Administracion/Permisos',
      name: 'ViewPermisos',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/permisos.view.vue')
    },
    {
      path: '/Administracion/Permisos/Asignar/:id',
      name: 'ViewPermissionsRoleAssign',
      props: true,
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/rolePermissionsAssign.view.vue')
    },
    {
      path: '/Administracion/Usuarios/AsignarMunicipios/:id',
      name: 'ViewMunicipiosRoleAssign',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Permisos' }
        ]
      },
      component: () => import('./views/administracion/roleAssignSection.view.vue')
    },
    {
      path: '/Administracion/Periodos',
      name: 'ViewPeridos',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Peridos' }
        ]
      },
      component: () => import('./views/administracion/periodos.view.vue')
    },
    {
      path: '/Administracion/Encuestas',
      name: 'ViewEncuestas',
      meta: {
        allowAnonymous: true,
        breadcrumb: [
          { name: 'Administracion' },
          { name: 'Encuestas' }
        ]
      },
      component: () => import('./views/administracion/encuestas.view.vue')
    }
  ]
})
